
export default {

  methods: {

    highlight({value, text, style = 'color: black;'}) {
      if (!text || text == '')
        return value;

      let index = value.toLowerCase().indexOf(text.toLowerCase());
      if (index == -1)
        return value;

      let str = value.substring(index, index + text.length);
      let html = `<span style=\'${style}\'>${str}</span>`;
      let result = value.substring(0, index) + html + value.substring(index + text.length);
      return result;
    }

  }

}



// WEBPACK FOOTER //
// ./src/mixins/highlightTextMixins.js